import _HOMPropertyService from "../services/hom-property-service";
import { IHOMPropertyService } from "../types/services/hom-property-service";

const instance = new _HOMPropertyService();

const HOMPropertyService: IHOMPropertyService = instance;

export default HOMPropertyService;
